import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  footer: {
    flexShrink: 0,
    width: '100%',
    borderTop: `1px solid ${theme.palette.gray?.border || '#edeef1'}`,
    background: theme.palette.background?.paper || '#ffffff',
    padding: '14px 24px',
    boxSizing: 'border-box',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    color: theme.palette.gray?.main || '#4e5978',
  },
  text: {
    color: theme.palette.gray?.main || '#4e5978',
  },
  separator: {
    color: theme.palette.gray?.light || '#888fa9',
  },
  link: {
    color: `${theme.palette.gray?.main || '#4e5978'} !important`,
    cursor: 'pointer',
    transition: 'color 0.2s ease',
    textDecoration: 'none',
    '&:hover': {
      color: `${theme.palette.primary.main} !important`,
    },
    '&:focus': {
      color: `${theme.palette.primary.main} !important`,
      outline: 'none',
    },
  },
}));

export default useStyles;
